import { createSlice } from "@reduxjs/toolkit";

export const theSlice = createSlice({
  name: 'reschedule-settings',
  initialState: {
    data: { enabled: false, windowDays: 2 },
    loaded: false,
  },
  reducers: {
    loadRescheduleSettings: (state, action) => {
      const data = action.payload;
      state.data = data;
      state.loaded = true;
    },
    updateRescheduleSetting: (state, action) => {
      const data = action.payload
      Object.assign(state.data, data);
    }
  }
});

export const {
  loadRescheduleSettings,
  updateRescheduleSetting,
} = theSlice.actions;
export default theSlice.reducer;
